import { defineComponent as Y, toRefs as le, ref as O, computed as i, watch as K, nextTick as Q, onBeforeUnmount as ve, provide as F, renderSlot as Z, unref as V, inject as b, reactive as de, onUnmounted as pe, mergeProps as fe, createCommentVNode as ge } from "vue";
import { nanoid as he } from "nanoid";
const ee = Symbol("hasFieldValue"), J = Symbol("getFieldValue"), te = Symbol("getFieldDefaultValue"), re = Symbol("getFieldPristine"), se = Symbol("getErrors"), T = Symbol("register"), ue = Symbol("validate"), oe = Symbol("getIsSubmitted"), ie = Symbol("getIsValidateAvailable"), Se = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getErrorsSymbol: se,
  getFieldDefaultValueSymbol: te,
  getFieldPristineSymbol: re,
  getFieldValueSymbol: J,
  getIsSubmittedSymbol: oe,
  getIsValidateAvailableSymbol: ie,
  hasFieldValueSymbol: ee,
  registerSymbol: T,
  validateSymbol: ue
}, Symbol.toStringTag, { value: "Module" }));
function ye(o, f) {
  let s = o;
  if (!X(s))
    return !1;
  const a = f.split(".");
  for (; a.length > 0; ) {
    const l = a.shift() ?? "";
    if (!(l in s))
      return !1;
    s = s[l];
  }
  return !0;
}
function W(o, f, s) {
  let a = o;
  if (!X(a))
    return s;
  const l = f.split(".");
  for (; l.length > 0; ) {
    const v = l.shift() ?? "";
    if (!(v in a))
      return s;
    a = a[v];
  }
  return a;
}
function be(o, f, s) {
  let a = o;
  if (!X(a))
    return;
  const l = f.split(".");
  for (; l.length > 1; ) {
    const v = l.shift() ?? "";
    X(a[v]) || (a[v] = Ve(l[0]) ? [] : {}), a = a[v];
  }
  a[l[0]] = s;
}
function Ve(o) {
  const f = Number(o);
  return !Number.isNaN(f);
}
function X(o) {
  return !!o && typeof o == "object";
}
const ne = "onFieldChange", ce = "onFormChange", _e = /* @__PURE__ */ Y({
  __name: "ValidationProvider",
  props: {
    defaultValues: { default: () => ({}) },
    defaultErrors: { default: () => ({}) },
    resolver: { default: () => (o) => ({ values: o, errors: {} }) },
    instantValidate: { type: Boolean, default: !1 },
    resetOnUpdate: { type: Boolean, default: !0 }
  },
  emits: ["submit", "dirty", "change"],
  setup(o, { expose: f, emit: s }) {
    const a = o, { defaultValues: l, defaultErrors: v, resolver: h, instantValidate: g, resetOnUpdate: M } = le(a), S = O(!1), L = O({}), d = O([]), E = O({}), y = i(() => d.value.reduce((e, r) => (e[r.name] = r, e), {})), u = i(() => d.value.reduce((e, { name: r, getValue: c }) => (be(e, r, c()), e), {})), N = i(() => d.value.some(({ dirty: e }) => e)), I = i(() => !d.value.some(({ pristine: e }) => !e)), m = i(() => d.value.reduce(
      (e, { name: r, errors: c }) => (e[r] = c, e),
      Object.assign({}, E.value)
    )), R = i(() => Object.values(m.value).some((e) => e.length)), _ = i(() => d.value.find(({ name: e }) => m.value[e].length)), P = i(() => S.value || g.value), D = i(() => R.value);
    K(l, () => {
      M.value && $();
    }), K(v, () => {
      M.value && $();
    }), K(
      N,
      (e) => {
        s("dirty", e);
      },
      {
        immediate: !0
      }
    ), K(u, async () => {
      const { values: e } = await A();
      s("change", e);
    }), $();
    async function $() {
      k(l.value), E.value = {};
      const e = Object.values(v.value).some((c) => c.length);
      if (!g.value && !e)
        return;
      await Q(), p(v.value, ne);
      const { errors: r } = await w();
      p(r), e && (S.value = !0);
    }
    const q = (e, r) => W(L.value, e, r), U = (e) => e ? m.value[e] || [] : m.value;
    async function j() {
      S.value = !0, E.value = {}, d.value.forEach(({ resetErrors: c }) => c());
      const { values: e, errors: r } = await w();
      if (p(r), R.value)
        return t();
      s("submit", e, {
        setError: C,
        reset: k,
        onFieldChange: z,
        focusInvalidField: t
      });
    }
    async function w(e) {
      const { values: r, errors: c } = await A();
      return d.value.forEach(({ resetErrors: G, errors: H, name: B }) => {
        if (e !== B) {
          const ae = H.filter(
            ({ resetBehaviour: me }) => me !== ce
          );
          c[B] = ae.concat(c[B] || []);
        }
        G();
      }), { values: r, errors: c };
    }
    function A() {
      return h.value(u.value);
    }
    function z(e, r) {
      y.value[e].onChange(r);
    }
    function k(e) {
      S.value = !1, e && (L.value = JSON.parse(JSON.stringify(e))), d.value.forEach(({ reset: r }) => {
        r();
      });
    }
    function p(e, r = ce) {
      Object.entries(e).forEach(([c, G]) => {
        G.forEach(({ message: H, type: B, resetBehaviour: ae = r }) => {
          C(c, { message: H, type: B, resetBehaviour: ae });
        });
      });
    }
    function C(e, r) {
      const { message: c, type: G, resetBehaviour: H = ne } = r, B = y.value[e];
      if (B) {
        B.setError({ message: c, type: G, resetBehaviour: H });
        return;
      }
      E.value[e] === void 0 && (E.value[e] = []), E.value[e].push({
        type: G,
        message: c,
        resetBehaviour: H
      });
    }
    function t() {
      return _.value && _.value.onFocus();
    }
    const n = (e) => {
      const r = e.name;
      return d.value.push(e), (E.value[r] || []).forEach((c) => {
        C(r, c);
      }), delete E.value[r], () => {
        x(e);
      };
    };
    function x(e) {
      if (d.value.length === 0)
        return;
      const r = d.value.indexOf(e);
      r !== -1 && d.value.splice(r, 1);
    }
    return ve(() => {
      d.value = [];
    }), F(T, n), F(ue, async (e) => {
      const { errors: r } = await w(e);
      d.value.forEach(({ resetErrors: c }) => {
        c();
      }), p(r);
    }), F(te, q), F(J, (e) => W(u.value, e)), F(re, (e) => {
      var r;
      return ((r = y.value[e]) == null ? void 0 : r.pristine) ?? !0;
    }), F(se, U), F(ee, (e) => ye(u.value, e)), F(oe, () => S.value), F(ie, () => P.value), f({
      handleSubmit: j,
      onFieldChange: z,
      reset: k,
      setError: C,
      focusInvalidField: t,
      values: u,
      dirty: N,
      pristine: I,
      invalid: D,
      errors: m,
      submitted: S
    }), (e, r) => Z(e.$slots, "default", {
      handleSubmit: j,
      onFieldChange: z,
      reset: k,
      setError: C,
      focusInvalidField: t,
      values: V(u),
      dirty: V(N),
      pristine: V(I),
      invalid: V(D),
      errors: V(m),
      submitted: S.value
    });
  }
}), Oe = /* @__PURE__ */ Y({
  __name: "ValidationField",
  props: {
    name: null,
    isEqual: { type: Function, default: (o, f) => o === f }
  },
  emits: ["should-focus", "change"],
  setup(o, { expose: f, emit: s }) {
    const a = o, { name: l, isEqual: v } = le(a), h = O(!1), g = O([]), M = b(ee), S = b(te), L = b(J), d = b(re), E = b(ie), y = b(T), u = b(ue), N = i(() => S(l.value)), I = i(() => M(l.value)), m = i(() => L(l.value)), R = i(() => E()), _ = O(I.value ? m.value : N.value), P = O(d(l.value)), D = i(() => !v.value(_.value, N.value)), $ = i(() => g.value[0]), q = i(() => !!g.value.length), U = () => {
      A(), Q(() => {
        j(N.value), P.value = !0;
      });
    }, j = (p) => {
      v.value(_.value, p) || (_.value = p, P.value = !1, s("change", p), R.value && u(l.value));
    }, w = ({
      message: p,
      type: C,
      resetBehaviour: t = ne
    }) => {
      g.value.push({
        type: C,
        message: p,
        resetBehaviour: t
      });
    }, A = () => {
      g.value.length && (g.value = []);
    }, z = de({
      name: l,
      dirty: D,
      pristine: P,
      errors: g,
      getValue: () => _.value,
      onChange: j,
      setError: w,
      resetErrors: A,
      reset: U,
      onFocus: () => {
        s("should-focus", {
          name: l.value
        });
      }
    });
    f({
      name: l,
      onChange: j,
      setError: w,
      modelValue: _,
      errors: g,
      firstError: $,
      dirty: D,
      invalid: q,
      pristine: P
    });
    const k = y(z);
    return pe(() => {
      k();
    }), h.value = !0, (p, C) => h.value ? Z(p.$slots, "default", fe({ key: 0 }, { name: V(l) }, {
      onChange: j,
      setError: w,
      modelValue: _.value,
      errors: g.value,
      firstError: V($),
      dirty: V(D),
      invalid: V(q),
      pristine: P.value
    })) : ge("", !0);
  }
}), Ne = /* @__PURE__ */ Y({
  __name: "ValidationFieldArray",
  props: {
    name: null,
    keyName: { default: "id" }
  },
  setup(o) {
    const f = o, { name: s, keyName: a } = le(f), l = b(re), v = O(l(s.value)), h = b(T), g = b(
      te
    ), M = b(J), S = i(() => g(s.value, [])), L = i(() => M(s.value) || []), d = i(() => {
      const t = {};
      return L.value.forEach((n) => {
        t[n[a.value]] = n;
      }), t;
    }), E = i(() => {
      const t = d.value;
      return u.value.map((n) => ({
        ...t[n[a.value]],
        [a.value]: n[a.value]
      }));
    }), y = O([]), u = O(N());
    function N() {
      return S.value.map((t) => ({
        ...t,
        [a.value]: I(t)
      }));
    }
    function I(t) {
      return a.value in t ? t[a.value] : he();
    }
    function m() {
      v.value = !1;
    }
    function R(t, n) {
      t[a.value] = I(t), u.value.push(t), m(), U(n);
    }
    function _(t, n) {
      t[a.value] = I(t), u.value.unshift(t), m(), U(n);
    }
    function P(t, n, x) {
      n[a.value] = I(n), u.value.splice(t, 0, n), m(), U(x);
    }
    function D(t, n) {
      const x = u.value[t];
      u.value[t] = u.value[n], u.value[n] = x, m();
    }
    function $(t, n) {
      u.value.splice(n, 0, u.value.splice(t, 1)[0]), m();
    }
    function q(t) {
      u.value.splice(t, 1), m();
    }
    function U(t) {
      t && Q(() => {
        const n = y.value.find(({ name: x }) => x === t.focusName);
        n && n.onFocus();
      });
    }
    const j = (t) => {
      const n = [...t];
      u.value = n, Q(() => {
        m(), y.value.forEach(({ name: x, onChange: e }) => {
          const r = p(x);
          e(W(n, r));
        });
      });
    }, w = () => {
      u.value = N(), v.value = !0;
    }, A = () => {
    }, z = de({
      name: s,
      dirty: !1,
      pristine: v,
      errors: [],
      getValue: () => u.value.map((t) => ({
        [a.value]: t[a.value]
      })),
      onChange: j,
      setError: A,
      resetErrors: A,
      reset: w,
      onFocus: A
    }), k = h(z);
    ve(() => {
      y.value = [], k();
    });
    function p(t) {
      return t.replace(new RegExp(`^${s.value}.`), "");
    }
    F(ee, () => !0), F(J, (t) => {
      const n = p(t);
      return W(u.value, n);
    }), F(T, (t) => {
      y.value.push(t);
      const n = h(t);
      return () => (C(t), n());
    });
    function C(t) {
      if (y.value.length === 0)
        return;
      const n = y.value.indexOf(t);
      n !== -1 && y.value.splice(n, 1);
    }
    return (t, n) => Z(t.$slots, "default", fe({ name: V(s) }, {
      onChange: j,
      fields: V(E),
      append: R,
      prepend: _,
      insert: P,
      swap: D,
      move: $,
      remove: q
    }));
  }
}), je = /* @__PURE__ */ Y({
  __name: "ValidationErrors",
  props: {
    name: { type: String, default: void 0 }
  },
  setup(o) {
    const f = o, s = b(oe), a = i(() => s()), l = b(se), v = i(() => {
      const h = l(f.name);
      return Array.isArray(h) ? h : Object.values(h).flat();
    });
    return (h, g) => Z(h.$slots, "default", {
      submitted: V(a),
      errors: V(v)
    });
  }
});
export {
  je as ValidationErrors,
  Oe as ValidationField,
  Ne as ValidationFieldArray,
  _e as ValidationProvider,
  W as get,
  ye as has,
  Se as symbols
};
